import { DrillDownState } from "@pma/types"
import { useState, useCallback } from "react"

// ---------------------------------------------------------------------------
// Drill-Down State — union of all possible drill-down targets
// ---------------------------------------------------------------------------

export function useDrillDown() {
  const [state, setState] = useState<DrillDownState>(null)

  const open = useCallback((next: NonNullable<DrillDownState>) => {
    setState(next)
  }, [])

  const close = useCallback(() => {
    setState(null)
  }, [])

  return { state, open, close } as const
}

export default useDrillDown
